import store from '@/vuex/store'
import { isBulkSlideAddSupported } from '@/services/office/insert-slides'

// AHA-46329: the multi-slide selector needs BOTH the flag and a PowerPoint that can
// export a slide as base64 (1.8). An unsupported host (iPad, volume-licensed perpetual
// Office incl. 2024 LTSC) must never reach the selector, because the Add button there
// could not do anything — so those users silently keep the original flow.
//
// This is its own module on purpose: services/office/index.js needs it, and importing it
// from ppt-select-presentation.js (which imports @/services/office) would be circular.
export const canUsePptSlideSelector = () => {
  return Boolean(store.getters['featureToggles/canUsePptMultipleSelect']) && isBulkSlideAddSupported()
}
